import request from '@/config/request.js'
import StudentDetail from '../student/index.vue'
import ClasstDetail from '../class/index.vue'
const ApilessonManagement = request.Course.lessonManagement
export default {
  name: 'lesson-management',
  components: {
    'student-detail': StudentDetail,
    'class-detail': ClasstDetail
  },
  data () {
    return {
      search_data: {
        filters: [{
          field: 'classroom.onlineClass.className',
          operator: 'like',
          value: ''
        }, {
          field: 'classroom.roomName',
          operator: 'like',
          value: ''
        }, {
          field: 'zoneTeacher.teacher.teacherName',
          operator: 'like',
          value: ''
        }, {
          field: 'beginTime',
          operator: 'dateBetween',
          value: []
        }, {
          field: 'endTime',
          operator: 'dateBetween',
          value: []
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        current_page: parseInt(this.$route.query.page) || 1,
        total: 0,
        page_size: 10,
        page_sizes: [10, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableList: [],
      anqindou: [],
      dailogStudent: false,
      studentTable: [],
      roomId: '',
      dailogClass: false,
      classTable: [],
      userId: ''
    }
  },
  computed: {
    tableHight: function () {
      return window.innerHeight - 385
    },
    loading: function () {
      return this.$store.state.global.ajax_loading
    }
  },
  methods: {
    getRoomType (type) {
      let str = ''
      switch (type) {
        case 'SMALL_CLASS':
          str = '互动课堂-小班课'
          break
        case 'SMALL_CLASS_LIVE':
          str = '直播教学-小班课'
          break
        case 'ONE_TO_ONE':
          str = '一对一'
          break
        case 'ONLINE_HOMEWORK':
          str = '线上作业托'
          break
        default:
          str = ''
      }
      return str
    },
    getDetail (row) {
      this.roomId = row.classroom.roomId
      ApilessonManagement.getClassroomActualUsers.call(this, { roomId: this.roomId }, (listData) => {
        this.studentTable = listData
        this.dailogStudent = true
      })
    },
    onGetClass (item) {
      this.userId = item.userId
      ApilessonManagement.getBroadcastEnterRecordsByRoomIdAndUserId.call(this, { roomId: this.roomId, userId: this.userId }, (listData) => {
        this.classTable = listData
        this.dailogClass = true
      })
    },
    resetTable () {
      this.search_data = {
        filters: [{
          field: 'classroom.onlineClass.className',
          operator: 'like',
          value: ''
        }, {
          field: 'classroom.roomName',
          operator: 'like',
          value: ''
        }, {
          field: 'zoneTeacher.teacher.teacherName',
          operator: 'like',
          value: ''
        }, {
          field: 'beginTime',
          operator: 'dateBetween',
          value: []
        }, {
          field: 'endTime',
          operator: 'dateBetween',
          value: []
        }]
      }
      this.onSearch()
    },
    /**
     * 搜索事件
     */
    onSearch () {
      const newQuery = {}
      this.$router.replace({ query: newQuery })
      var where = []
      for (var s in this.search_data.filters) {
        if (this.search_data.filters[s].value) {
          where.push(this.search_data.filters[s])
        }
      }
      this.getList({
        where
      })
    },
    /**
     * 改变页码和当前页时需要拼装的路径方法
     * @param {string} field 参数字段名
     * @param {string} value 参数字段值
     */
    setPath (field, value) {
      var path = this.$route.path
      var query = Object.assign({}, this.$route.query)

      if (typeof field === 'object') {
        query = field
      } else {
        query[field] = value
      }
      this.$router.push({
        path,
        query
      })
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.getList({
        page,
        fn: () => {
          this.setPath('page', page)
        }
      })
    },
    /**
     * 改变每页显示数量事件
     * @param  {number} size 当前每页显示数量
     */
    onChangePageSize (pageSize) {
      this.getList({
        pageSize,
        fn: () => {
          this.setPath('page_size', pageSize)
        }
      })
    },
    /**
     * 获取用户信息列表
     * @param  {number} options.page      当前页码，切换页码时用
     * @param  {number} options.page_size 每页显示数量，改变每页数量时用
     * @param  {function} options.fn                            } 获取列表后的回调函数
     */
    getList ({
      page,
      pageSize,
      where,
      fn
    } = {}) {
      var query = this.$route.query
      this.paginations.current_page = page || parseInt(query.page) || 1
      this.paginations.page_size = pageSize || parseInt(query.page_size) || this.paginations.page_size
      var data = {
        offset: (this.paginations.current_page - 1) * this.paginations.page_size,
        limit: this.paginations.page_size,
        data: null,
        filters: null,
        orFilters: null,
        order: 'desc',
        sort: 'createTime'
      }
      if (where) {
        data = Object.assign(data, { filters: where } || {})
      } else {
        var queryArr = []
        for (var s in this.search_data.filters) {
          if (this.search_data.filters[s].value) {
            queryArr.push(this.search_data.filters[s])
          }
        }
        data = Object.assign(data, { filters: queryArr } || {})
      }
      ApilessonManagement.pageFlowBill.call(this, data, (listData) => {
        this.tableList = listData.content
        this.paginations.total = parseInt(listData.totalElements)
        fn && fn()
      })
    }
  },
  mounted () {
    this.getList()
    ApilessonManagement.flowRecharge.call(this, {}, (listData) => {
      this.anqindou = listData
    })
  }
}
